module.exports = __webpack_public_path__ + "static/media/bgDotted.29159892.png";